import { IfAllowedAnyDirective } from './if-allowed-any.directive'
import { IfAllowedDirective } from './if-allowed.directive'
import { IfDisallowedDirective } from './if-disallowed.directive'
import { IfNotAllowedDirective } from './if-not-allowed.directive'
import { MainContentDirective } from './main-content.directive'
import { PerfectScrollbarDirective } from './perfect-scrollbar.directive'
import { SubMainContentDirective } from './sub-main-content.directive'
import { CollapsebleDirective } from './collapseble.directive'

export { IfAllowedAnyDirective }
export { IfAllowedDirective }
export { IfNotAllowedDirective }
export { MainContentDirective }
export { PerfectScrollbarDirective }
export { SubMainContentDirective }
export { CollapsebleDirective }

export const COMMON_DIRECTIVES = [
  IfAllowedAnyDirective,
  IfAllowedDirective,
  IfDisallowedDirective,
  IfNotAllowedDirective,
  MainContentDirective,
  PerfectScrollbarDirective,
  SubMainContentDirective,
  CollapsebleDirective
]



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./app/common/directives/index.ts